import { Link } from "react-router-dom";
import { Radar, ArrowLeft, Check, Mail } from "lucide-react";
import { Button } from "../components/ui/button";

const PLANS = [
  {
    key: "individual",
    name: "Plan Individual",
    price: "9,90 €",
    period: "/ mes",
    tagline: "Para gestionar tu economía personal.",
    highlight: false,
    features: [
      "Radar de patrimonio en tiempo real",
      "Gastos, ingresos y compromisos ilimitados",
      "Proyecciones a 12 meses",
      "1 usuario titular",
      "Soporte por email",
    ],
  },
  {
    key: "familiar",
    name: "Plan Familiar",
    price: "19,90 €",
    period: "/ mes",
    tagline: "Toda tu familia bajo un mismo radar.",
    highlight: true,
    features: [
      "Todo lo del Plan Individual",
      "Hasta 5 miembros de la familia",
      "Roles y permisos (Admin, Editor, Consulta)",
      "PIN secundario para datos sensibles",
      "Auditoría completa de movimientos",
      "Soporte prioritario",
    ],
  },
];

export default function Planes() {
  return (
    <div className="min-h-screen bg-background text-foreground">
      <header className="border-b border-border">
        <div className="max-w-6xl mx-auto px-6 py-5 flex items-center justify-between">
          <Link to="/login" className="flex items-center gap-2 hover:opacity-80 transition-opacity" data-testid="planes-brand">
            <Radar size={22} strokeWidth={2.5} />
            <span className="font-heading font-extrabold tracking-tight">RADAR FINANCIERO</span>
          </Link>
          <Link to="/login" className="text-sm text-muted-foreground hover:text-foreground flex items-center gap-1" data-testid="planes-back-login">
            <ArrowLeft size={14} /> Volver al acceso
          </Link>
        </div>
      </header>

      <main className="max-w-6xl mx-auto px-6 py-12 lg:py-20" data-testid="planes-page">
        <div className="text-center max-w-2xl mx-auto mb-14">
          <h1 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tighter">Elige tu plan</h1>
          <p className="mt-4 text-muted-foreground">
            Radar Financiero es un servicio de acceso exclusivo. Contrata un plan y recibirás tus credenciales por email en menos de 24h.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-4xl mx-auto">
          {PLANS.map((p) => (
            <div
              key={p.key}
              data-testid={`plan-card-${p.key}`}
              className={`rounded-2xl border p-8 flex flex-col ${p.highlight ? "border-primary bg-primary/[0.03] shadow-lg" : "border-border"}`}
            >
              {p.highlight && (
                <span className="self-start text-[10px] font-bold uppercase tracking-[0.2em] bg-primary text-primary-foreground px-2 py-1 rounded mb-3">Más popular</span>
              )}
              <h3 className="font-heading text-2xl font-extrabold tracking-tight">{p.name}</h3>
              <p className="text-sm text-muted-foreground mt-1">{p.tagline}</p>
              <div className="mt-6 flex items-baseline gap-1">
                <span className="text-4xl font-extrabold tabular tracking-tighter">{p.price}</span>
                <span className="text-muted-foreground text-sm">{p.period}</span>
              </div>
              <ul className="mt-6 space-y-2.5 flex-1">
                {p.features.map((f) => (
                  <li key={f} className="text-sm flex items-start gap-2">
                    <Check size={15} className="text-primary shrink-0 mt-0.5" />
                    <span>{f}</span>
                  </li>
                ))}
              </ul>
              <a
                href="mailto:hola@radarupfinance.com?subject=Contrataci%C3%B3n%20de%20plan%20Radar%20Financiero"
                data-testid={`plan-cta-${p.key}`}
                className="mt-8"
              >
                <Button className="w-full h-11" variant={p.highlight ? "default" : "outline"}>
                  <Mail size={15} className="mr-2" /> Contratar {p.name.split(" ")[1]}
                </Button>
              </a>
            </div>
          ))}
        </div>

        <div className="mt-16 text-center text-sm text-muted-foreground">
          <p>¿Necesitas un plan a medida o tienes dudas? Escríbenos a <a href="mailto:hola@radarupfinance.com" className="underline hover:text-foreground">hola@radarupfinance.com</a></p>
        </div>
      </main>
    </div>
  );
}
